import { mascaraDinheiro, textoParaCentavos } from '@/pages/assistente-evento/utils';

interface CampoDinheiroProps {
  id: string;
  name: string;
  label: string;
  help?: string;
  centavos: number;
  onChange: (centavos: number) => void;
  required?: boolean;
  error?: string | null;
  placeholder?: string;
}

export default function CampoDinheiro({
  id,
  name,
  label,
  help,
  centavos,
  onChange,
  required,
  error,
  placeholder,
}: CampoDinheiroProps) {
  const texto = centavos === 0 ? '' : mascaraDinheiro(String(centavos));

  return (
    <div>
      <label htmlFor={id} className="block text-base font-medium text-foreground-950">
        {label} {required && <span className="text-danger-600">*</span>}
      </label>
      {help && <p className="mt-1 text-sm text-secondary-500">{help}</p>}
      <div className="relative mt-1">
        <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-[15px] text-secondary-500">
          R$
        </span>
        <input
          id={id}
          name={name}
          inputMode="numeric"
          value={texto.replace(/^R\$\s?/, '')}
          onChange={(e) => onChange(textoParaCentavos(e.target.value))}
          placeholder={placeholder ?? '0,00'}
          className={`w-full rounded-md border bg-white py-2 pl-10 pr-3 text-[15px] text-foreground-950 outline-none transition-colors placeholder:text-secondary-400 focus:border-primary-500 ${
            error ? 'border-danger-500' : 'border-secondary-300'
          }`}
        />
      </div>
      {error && (
        <p className="mt-1 text-sm text-danger-600" role="alert" data-erro="true">
          {error}
        </p>
      )}
    </div>
  );
}